import React from 'react';
interface PriceItem {
  id: number;
  title: string;
  prices: {
    title: string | React.ReactNode;
    subtitle?: React.ReactNode;
    time: string | null;
    price: string | null;
    prices?: React.ReactNode;
    disable_background?: boolean
  }[]
}

export const pricelist: PriceItem[] = [
    {
      id: 0,
      title: "USG",
      prices: [
        {
          title: "USG dzieci (6-18r.ż.) - jeden rodzaj badania",
          time: null,
          price: '250zł',
        },
        {
          title: "USG piersi",
          time: null,
          price: '250zł',
        },
        {
          title: "USG jamy brzusznej",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG tarczycy i przytarczyc",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG węzłów chłonnych",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG ślinianek",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG jąder",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG tkanek miękkich (skóra, tkanka podskórna, blizny)",
          time: '15min',
          price: '200zł',
        },
        {
          title: "USG szyi (tarczyca i przytarczyce, ślinianki, węzły chłonne)",
          time: '30min',
          price: '250zł',
        },
        {
          title: "USG układu moczowego (nerki, moczowody, pęcherz moczowy)",
          time: '15min',
          price: '170zł',
        },
        {
          title: "USG doppler tętnic szyjnych i kręgowych",
          time: '15min',
          price: '250zł',
        },
        {
          title: "USG doppler naczyń żylnych jednej kończyny górnej",
          time: null,
          price: '250zł',
        },
        {
          title: "USG doppler naczyń żylnych jednej kończyny dolnej",
          time: null,
          price: '250zł',
        },
        {
          title: "USG doppler naczyń żylnych obu kończyn górnych",
          time: null,
          price: '400zł',
        },
        {
          title: "USG doppler naczyń żylnych obu kończyn dolnych",
          time: null,
          price: '400zł',
        },
        {
          title: "USG doppler naczyń tętniczych jednej kończyny górnej",
          time: null,
          price: '250zł',
        },
        {
          title: "USG doppler naczyń tętniczych jednej kończyny dolnej",
          time: null,
          price: '250zł',
        },
        {
          title: "USG doppler naczyń tętniczych obu kończyn górnych",
          time: null,
          price: '400zł',
        },
        {
          title: "USG doppler naczyń tętniczych obu kończyn dolnych",
          time: null,
          price: '400zł',
        },
        {
          title: "USG doppler wątroby",
          time: '15min',
          price: '250zł',
        },
        {
          title: "USG barku",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG stawu łokciowego",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG stawu kolanowego",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG stawu skokowego",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG stawu biodrowego",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG nadgarstka",
          time: '30min',
          price: '230zł',
        },
        {
          title: "USG ścięgna Achillesa",
          time: '20min',
          price: '200zł',
        }
      ]
    },
    {
      id: 1,
      title: "REHABILITACJA",
      prices: [
        {
          title: "Konsultacja lek. rehabilitacji (w tym badanie USG)",
          time: '30min',
          price: '230zł',
        },
        {
          title: "Konsultacja lek. rehabilitacji (w tym badanie USG) + kolagenoterapia iniekcyjna pierwsza dawka",
          time: null,
          price: '350zł',
        },
        {
          title: "Kolagenoterapia iniekcyjna kolejne dawki",
          time: null,
          price: '210zł',
        },
        {
          title: "Konsultacja lek rehabilitacji (w tym badanie USG) + suche igłowanie pierwszy zabieg",
          time: null,
          price: '350zł',
        },
        // {
        //   title: "Zabieg suchego igłowania",
        //   time: '30min',
        //   price: '190zł',
        // },
        // {
        //   title: "Suche igłowanie kolejne zabiegi",
        //   time: '30min',
        //   price: '120zł',
        // },
        {
          title: "Suche igłowanie kolejne zabiegi",
          time: '30min',
          price: '120zł',
        },
        // {
        //   title: "Zabieg z użyciem osocza bogatopłytkowego",
        //   time: '30min',
        //   price: '800zł',
        // },
        {
          title: "iniekcja kwasu hialuronowego (cena nie obejmuje preparatu)",
          time: null,
          price: '190zł',
        },
        {
          title: "Iniekcja z lekiem przeciwbólowym i przeciwzapalnym „blokada",
          time: null,
          price: '190zł',
        },
        {
          title: "Iniekcja okołokręgowa",
          time: null,
          price: '400zł',
        },
        // {
        //   title: "Mezoterapia kręgosłupa",
        //   time: null,
        //   price: '250zł',
        // },
        // {
        //   title: "Mezoterapia tkanek miękkich",
        //   time: '20min',
        //   price: '250zł',
        // },
        // {
        //   title: "Zabieg kolagenoterapii dostawowej",
        //   time: '20min',
        //   price: '250zł',
        // },
      ]
    },
    {
      id: 2,
      title: "REUMATOLOGIA",
      prices: [
        {
          title: "Konsultacja reumatologiczna",
          time: null,
          price: '220zł',
        }
      ]
    },
    {
      id: 3,
      title: "CHIRURGIA",
      prices: [
        {
          title: "Konsultacja chirurgiczna",
          time: '15min',
          price: '170zł',
        },
        {
          title: "Zabieg usunięcia zmiany skórnej (w zależności od ilości, umiejscowienia zmian)",
          time: '30min',
          price: 'od 400zł',
        },
        {
          title: "Badanie histopatologiczne zmiany skórnej (cena dotyczy jednej zmiany)",
          time: null,
          price: '50zł',
        },
      ]
  },
  {
    id: 4,
    title: "BADANIA DIAGNOSTYCZNE",
    prices: [
      {
        title: "Test Schirmera",
        time: null,
        price: '30zł',
      },
      {
        title: <span>Biopsja gruczołu ślinowego <br />(cena zawiera badanie histopatologiczne 50 zł)</span>,
        
        time: null,
        price: '200zł',
      },
      {
        title: "Biopsja cienkoigłowa:",
        time: null,
        price: null,
      },
      {
        disable_background: true,
        title: <ul><li>Pierwsza zmiana (cena zawiera badanie histopatologiczne 85zł)</li></ul>,
        price: '235zł',
        time: null
      },
      {
        title:  <ul><li>Każda kolejna zmiana podczas tej samej wizyty <br/> (cena zawiera badanie histopatologiczne 85zł)</li></ul>,
        price: '135zł',
        time: null
      },
      {
        title: "Kapilaroskopia",
        price: '150zł',
        time: null
      }
    ]
  },
  // {
  //   id: 4,
  //   title: "PEDIATRIA",
  //   prices: [
  //     {
  //       title: "Konsultacja pediatryczna",
  //       time: null,
  //       price: '220zł',
  //     },
  //     {
  //       title: "Test półilościowy (test CRP, test Strep A, test Combo: Covid-19, grypa, RSV)",
        
  //       time: null,
  //       price: '10zł',
  //     },
  //   ]
  // },
  {
    id: 4,
    title: "NEUROLOGIA",
    prices: [
      {
        title: "Konsultacja neurologiczna",
        time: null,
        price: '150zł',
      },
    ]
  },
  {
    id: 4,
    title: "ENDOKRYNOLOGIA",
    prices: [
      {
        title: "Konsultacja endokrynologiczna",
        time: null,
        price: '250zł',
      },
    ]
  },
  ];